import api from './client/axios';

interface PresignedUrlResponse {
  uploadUrl: string;
  viewUrl: string;
}

export const uploadToS3 = async (
  uploadUrl: string,
  file: File,
): Promise<void> => {
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type },
  });
  if (!response.ok) throw new Error('Failed to upload file to S3.');
};

export const getPresignedUrl = async (
  ticketId: string,
  file: File,
): Promise<PresignedUrlResponse> => {
  const presignPayload = {
    filename: file.name,
    contentType: file.type,
    size: file.size,
  };
  const response = await api.post(
    `/uploads/${ticketId}/presigned-url`,
    presignPayload,
  );
  if (!response.data) throw new Error('Failed to get presigned URL.');
  return response.data;
};

export const getS3ObjectUrl = async (uploadId: string): Promise<any> => {
  const response = await api.get(`/uploads/${uploadId}/view-url`);
  return response.data;
};

export const deleteUpload = async (uploadId: string): Promise<any> => {
  const response = await api.delete(`/uploads/${uploadId}`);
  return response.data.data!;
};
